import Vue from 'vue'
import Router from 'vue-router'
import NormalTable from '../components/template/NormalTable'
import api from '../views/api/Index'

Vue.use(Router)


import Index from '@/views/Index'

export const constantRoutes = [
    {
      path: "/login",
      component: () => import('@/views/Login'),
      hidden: true
    },
    {
      path: '/404',
      component: () => import('@/views/404'),
      hidden: true
    },
    {
      path: '/shop-list',
      component: () => import('@/views/shop/shop-list'),
      hidden: true
    },
    {
      path: '/',
      redirect: '/home',
      component: Index,
      children: [
        {
          path: "/home",
          name: '公卫管理系统',
          component: () => import('@/views/Home'),
          meta:{
            title: '首页'
          }
        }
      ]
    },
  {
    path: '/',
    redirect: '/store',
    component: Index,
    children: [
      {
        path: "/home",
        name: '公卫管理系统',
        component: () => import('@/views/Home'),
        meta:{
          title: '首页'
        }
      }
    ]
  },
    {
      path: "/api",
      redirect: '/api-form',
      component: api,
      children: [
        {
          path: "/api-form",
          name: '表格',
          component: () => import('@/views/api/form/index'),
          meta:{
            title: '表格'
          }
        },
        {
          path: "/api-table",
          name: '表格',
          component: () => import('@/views/api/table/index'),
          meta:{
            title: '表格'
          }
        }
      ]
    }
]


const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router




// WEBPACK FOOTER //
// ./src/router/index.js